// src/shared/api/client.ts
import axios from 'axios';
import { env } from '@/shared/config/env';

export const axiosInstance = axios.create({
  baseURL: env.API_URL,
  timeout: 60_000,
});
